const ITEMS = [
  "Butter Chicken Tandoor",
  "Spicy Nagpur Savji Specials",
  "Afghani & Malai Tikka",
  "Fragrant Dum Biryani",
  "Mughlai & Handi Gravies",
  "Sizzling Tandoori Naan",
  "Indo-Chinese Soups & Platters",
];

export default function Marquee() {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee-banner"
      className="bg-[#111D25] py-3.5 border-b border-[#1E313D] overflow-hidden"
    >
      <div className="marquee-track text-xs font-semibold tracking-widest uppercase text-[#D4AF37] gap-12">
        {doubled.map((item, i) => (
          <span key={i}>• {item}</span>
        ))}
      </div>
    </div>
  );
}
